var observable = (function () { return (typeof Symbol === 'function' && Symbol.observable) || '@@observable'; })();

export { observable };
//# sourceMappingURL=observable.js.map
